import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  Button,
  ListGroup,
  ListGroupItem,
  Progress
} from "shards-react";

const UserDetails = ({userDetails}) => (
  <Card small className="mb-4 pt-3">
    <CardHeader className="border-bottom text-center">
      <div className="mb-3 mx-auto">
        <img
          className="rounded-circle"
          src={userDetails.avatar}
          alt={userDetails.name}
          width="110"
        />
      </div>
      <h4 className="mb-0">{userDetails.name}</h4>
      <span className="text-muted d-block mb-2">{userDetails.jobTitle}</span>
      <span
        className="text-muted d-block mb-2">e-mail: ironquest.games@gmail.com</span>
    </CardHeader>
    <ListGroup flush>
      <ListGroupItem className="px-4">
        <div className="progress-wrapper">
        </div>
      </ListGroupItem>
      <ListGroupItem className="p-4">
        <strong className="text-muted d-block mb-2">
          {userDetails.metaTitle}
        </strong>
        <span>{userDetails.metaValue}</span>
      </ListGroupItem>
    </ListGroup>
  </Card>
);

UserDetails.propTypes = {
  /**
   * The user details object.
   */
  userDetails: PropTypes.object
};

UserDetails.defaultProps = {
  userDetails: {
    name: "Iron Quest",
    avatar: require("./../../images/avatars/avatar.svg"),
    jobTitle: "Herní studio",
    performanceReportTitle: "Workload",
    performanceReportValue: 74,
    metaTitle: "Popis",
    metaValue:
      "Portál Herní zóna je nyní pod správou studia Iron Quest. Stránka slouží jako rozcestník oblíbených her. Naleznete zde běžné odreagovačky, ale i hry, které byly ukončeny s koncem Flash Playeru, například Slovní Fotbal nebo Dobyvatel. Součástí portálu je i hra Kris Kros."
  }
};

export default UserDetails;
